import moment from "moment";
import { generateNarFilePath } from "../../../../pages/configurations/pages/narConfiguration/utils/generateNarFilePath";

/**
 * Generates a file path for NAR ingestion based on the selected insurance, plan, date, and file type.
 *
 * @param selectedInsurance - The selected insurance provider name
 * @param selectedPlan - The selected plan name under the insurance
 * @param selectedDate - The date string in MM/DD/YYYY format (or other parseable format)
 * @param fileType - The type of file being uploaded ("pdf" or "csv")
 * @returns The generated file path string, or an empty string if inputs are invalid
 */
export const getFilePathForIngestion = (
  selectedInsurance: string,
  selectedPlan: string,
  selectedDate: string,
  fileType: "pdf" | "csv",
): string => {
  if (!selectedInsurance || !selectedPlan || !selectedDate) {
    return "";
  }

  let date = moment(selectedDate, "MM/DD/YYYY", true);
  if (!date.isValid()) {
    date = moment(selectedDate);
  }

  if (!date.isValid()) {
    return "";
  }

  const month = date.month() + 1;
  const year = date.year();
  const day = date.date();

  if (isNaN(month) || isNaN(year) || isNaN(day)) {
    return "";
  }

  return generateNarFilePath(
    selectedInsurance,
    selectedPlan,
    day,
    month,
    year,
    fileType,
    true,
  );
};
